/* tslint:disable */
/* eslint-disable */
/**
 * Viewup Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../../base';
// @ts-ignore
import type { DeleteViewupPlusSnsAccountByViewupPlusSnsAccountUuidForbiddenDto } from '../../src/model';
// @ts-ignore
import type { DeleteViewupPlusSnsAccountByViewupPlusSnsAccountUuidInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { DeleteViewupPlusSnsAccountByViewupPlusSnsAccountUuidNotFoundDto } from '../../src/model';
// @ts-ignore
import type { DeleteViewupSnsAccountByViewupSnsAccountUuidForbiddenDto } from '../../src/model';
// @ts-ignore
import type { DeleteViewupSnsAccountByViewupSnsAccountUuidInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { DeleteViewupSnsAccountByViewupSnsAccountUuidNotFoundDto } from '../../src/model';
// @ts-ignore
import type { GetActiveViewupSnsAccountsByUserUuidInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { GetActiveViewupSnsAccountsByUserUuidOkDto } from '../../src/model';
// @ts-ignore
import type { GetAmountBeDeductedInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { GetAmountBeDeductedNotFoundDto } from '../../src/model';
// @ts-ignore
import type { GetAmountBeDeductedOkDto } from '../../src/model';
// @ts-ignore
import type { GetApprovedViewupPlusSnsAccountsInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { GetApprovedViewupPlusSnsAccountsOkDto } from '../../src/model';
// @ts-ignore
import type { GetViewupPlusSnsAccountsByUserUuidInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { GetViewupPlusSnsAccountsByUserUuidOkDto } from '../../src/model';
// @ts-ignore
import type { GetViewupSnsAccountsByUserUuidInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { GetViewupSnsAccountsByUserUuidOkDto } from '../../src/model';
// @ts-ignore
import type { JwtAccessGuardUnauthorizedDto } from '../../src/model';
// @ts-ignore
import type { PatchViewupPlusSnsAccountByViewupPlusSnsAccountUuidForbiddenDto } from '../../src/model';
// @ts-ignore
import type { PatchViewupPlusSnsAccountByViewupPlusSnsAccountUuidForbiddenNotApprovedDto } from '../../src/model';
// @ts-ignore
import type { PatchViewupPlusSnsAccountByViewupPlusSnsAccountUuidInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { PatchViewupPlusSnsAccountByViewupPlusSnsAccountUuidNotFoundDto } from '../../src/model';
// @ts-ignore
import type { PatchViewupPlusSnsAccountByViewupPlusSnsAccountUuidReqBodyDto } from '../../src/model';
// @ts-ignore
import type { PatchViewupSnsAccountByViewupSnsAccountUuidForbiddenDto } from '../../src/model';
// @ts-ignore
import type { PatchViewupSnsAccountByViewupSnsAccountUuidForbiddenNotApprovedDto } from '../../src/model';
// @ts-ignore
import type { PatchViewupSnsAccountByViewupSnsAccountUuidForbiddenNotInstagramDto } from '../../src/model';
// @ts-ignore
import type { PatchViewupSnsAccountByViewupSnsAccountUuidInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { PatchViewupSnsAccountByViewupSnsAccountUuidNotFoundDto } from '../../src/model';
// @ts-ignore
import type { PatchViewupSnsAccountByViewupSnsAccountUuidReqBodyDto } from '../../src/model';
// @ts-ignore
import type { PatchViewupSnsAccountIsActiveByViewupSnsAccountForbiddenDto } from '../../src/model';
// @ts-ignore
import type { PatchViewupSnsAccountIsActiveByViewupSnsAccountForbiddenNotApprovedDto } from '../../src/model';
// @ts-ignore
import type { PatchViewupSnsAccountIsActiveByViewupSnsAccountInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { PatchViewupSnsAccountIsActiveByViewupSnsAccountNotFoundDto } from '../../src/model';
// @ts-ignore
import type { PatchViewupSnsAccountOnlyActiveInPlatformBySnsAccountUuidForbiddenErrorDto } from '../../src/model';
// @ts-ignore
import type { PatchViewupSnsAccountOnlyActiveInPlatformBySnsAccountUuidForbiddenNotApprovedErrorDto } from '../../src/model';
// @ts-ignore
import type { PatchViewupSnsAccountOnlyActiveInPlatformBySnsAccountUuidInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { PatchViewupSnsAccountOnlyActiveInPlatformBySnsAccountUuidNotFoundDto } from '../../src/model';
// @ts-ignore
import type { PatchViewupSnsAccountOnlyActiveInPlatformBySnsAccountUuidOkDto } from '../../src/model';
// @ts-ignore
import type { PostFacebookAccountByUserUuidBadGatewayDto } from '../../src/model';
// @ts-ignore
import type { PostFacebookAccountByUserUuidForbiddenAnotherUserDto } from '../../src/model';
// @ts-ignore
import type { PostFacebookAccountByUserUuidInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { PostFacebookAccountByUserUuidReqBodyDto } from '../../src/model';
// @ts-ignore
import type { PostFacebookAccountByUserUuidUnauthorizedDto } from '../../src/model';
// @ts-ignore
import type { PostInstagramAccountByUserUuidBadGatewayDto } from '../../src/model';
// @ts-ignore
import type { PostInstagramAccountByUserUuidConflictAnotherTypeDto } from '../../src/model';
// @ts-ignore
import type { PostInstagramAccountByUserUuidForbiddenAnotherUserDto } from '../../src/model';
// @ts-ignore
import type { PostInstagramAccountByUserUuidForbiddenDeviceCheckDto } from '../../src/model';
// @ts-ignore
import type { PostInstagramAccountByUserUuidForbiddenOTPCheckDto } from '../../src/model';
// @ts-ignore
import type { PostInstagramAccountByUserUuidForbiddenSMSCheckDto } from '../../src/model';
// @ts-ignore
import type { PostInstagramAccountByUserUuidForbiddenTooManyAccountDto } from '../../src/model';
// @ts-ignore
import type { PostInstagramAccountByUserUuidInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { PostInstagramAccountByUserUuidNotFoundSnsIdDto } from '../../src/model';
// @ts-ignore
import type { PostInstagramAccountByUserUuidReqBodyDto } from '../../src/model';
// @ts-ignore
import type { PostInstagramAccountByUserUuidUnauthorizedCodeDto } from '../../src/model';
// @ts-ignore
import type { PostInstagramAccountByUserUuidUnauthorizedDeviceDto } from '../../src/model';
// @ts-ignore
import type { PostInstagramAccountByUserUuidUnauthorizedPasswordDto } from '../../src/model';
// @ts-ignore
import type { PostLogoutSnsAccountInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { PostLogoutSnsAccountLoginFailedDto } from '../../src/model';
// @ts-ignore
import type { PostLogoutSnsAccountRequestBodyDto } from '../../src/model';
// @ts-ignore
import type { PostLogoutSnsAccountResponseOkDto } from '../../src/model';
// @ts-ignore
import type { PostThreadsAccountByUserUuidBadGatewayDto } from '../../src/model';
// @ts-ignore
import type { PostThreadsAccountByUserUuidForbiddenAnotherUserDto } from '../../src/model';
// @ts-ignore
import type { PostThreadsAccountByUserUuidForbiddenDeviceCheckDto } from '../../src/model';
// @ts-ignore
import type { PostThreadsAccountByUserUuidForbiddenOTPCheckDto } from '../../src/model';
// @ts-ignore
import type { PostThreadsAccountByUserUuidForbiddenSMSCheckDto } from '../../src/model';
// @ts-ignore
import type { PostThreadsAccountByUserUuidInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { PostThreadsAccountByUserUuidNotFoundSnsIdDto } from '../../src/model';
// @ts-ignore
import type { PostThreadsAccountByUserUuidReqBodyDto } from '../../src/model';
// @ts-ignore
import type { PostThreadsAccountByUserUuidUnauthorizedCodeDto } from '../../src/model';
// @ts-ignore
import type { PostThreadsAccountByUserUuidUnauthorizedDeviceDto } from '../../src/model';
// @ts-ignore
import type { PostThreadsAccountByUserUuidUnauthorizedPasswordDto } from '../../src/model';
// @ts-ignore
import type { PostYoutubeAccountByUserUuidBadGatewayDto } from '../../src/model';
// @ts-ignore
import type { PostYoutubeAccountByUserUuidForbiddenAnotherUserDto } from '../../src/model';
// @ts-ignore
import type { PostYoutubeAccountByUserUuidInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { PostYoutubeAccountByUserUuidReqBodyDto } from '../../src/model';
// @ts-ignore
import type { PostYoutubeAccountByUserUuidUnauthorizedDto } from '../../src/model';
/**
 * SnsAccountsApi - axios parameter creator
 * @export
 */
export const SnsAccountsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 뷰업 플러스 SNS 계정 삭제
         * @param {string} snsAccountUuid sns 계정 uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        snsAccountControllerDeleteViewupPlusSnsAccountBySnsAccountUuid: async (snsAccountUuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'snsAccountUuid' is not null or undefined
            assertParamExists('snsAccountControllerDeleteViewupPlusSnsAccountBySnsAccountUuid', 'snsAccountUuid', snsAccountUuid)
            const localVarPath = `/sns-accounts/viewupPlus/{snsAccountUuid}`
                .replace(`{${"snsAccountUuid"}}`, encodeURIComponent(String(snsAccountUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication accessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 뷰업 SNS 계정 삭제
         * @param {string} snsAccountUuid sns 계정 uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        snsAccountControllerDeleteViewupSnsAccountBySnsAccountUuid: async (snsAccountUuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'snsAccountUuid' is not null or undefined
            assertParamExists('snsAccountControllerDeleteViewupSnsAccountBySnsAccountUuid', 'snsAccountUuid', snsAccountUuid)
            const localVarPath = `/sns-accounts/viewup/{snsAccountUuid}`
                .replace(`{${"snsAccountUuid"}}`, encodeURIComponent(String(snsAccountUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication accessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 활성화 뷰업 SNS 계정 목록 조회
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        snsAccountControllerGetActiveViewupSnsAccountsByUserUuid: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/sns-accounts/viewup/active`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication accessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 계정 삭제시 차감 예정 금액
         * @param {string} snsAccountUuid sns 계정 uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        snsAccountControllerGetAmountBeDeducted: async (snsAccountUuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'snsAccountUuid' is not null or undefined
            assertParamExists('snsAccountControllerGetAmountBeDeducted', 'snsAccountUuid', snsAccountUuid)
            const localVarPath = `/sns-accounts/viewup/{snsAccountUuid}/amountBeDeducted`
                .replace(`{${"snsAccountUuid"}}`, encodeURIComponent(String(snsAccountUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication accessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 모두그램에서 호출: 뷰플 승인 계정 목록
         * @param {boolean} [isActivity] 활동기능 여부
         * @param {boolean} [isRegram] 리그램 여부
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        snsAccountControllerGetApprovedViewupPlusSnsAccounts: async (isActivity?: boolean, isRegram?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/sns-accounts/viewupPlus/approved`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (isActivity !== undefined) {
                localVarQueryParameter['isActivity'] = isActivity;
            }

            if (isRegram !== undefined) {
                localVarQueryParameter['isRegram'] = isRegram;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 뷰업 플러스 SNS 계정 목록 조회
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        snsAccountControllerGetViewupPlusSnsAccountsByUserUuid: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/sns-accounts/viewupPlus`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication accessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 뷰업 SNS 계정 목록 조회
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        snsAccountControllerGetViewupSnsAccountsByUserUuid: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/sns-accounts/viewup`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication accessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 뷰플 SNS 계정 수정
         * @param {string} snsAccountUuid sns 계정 uuid
         * @param {PatchViewupPlusSnsAccountByViewupPlusSnsAccountUuidReqBodyDto} patchViewupPlusSnsAccountByViewupPlusSnsAccountUuidReqBodyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        snsAccountControllerPatchViewupPlusSnsAccountBySnsAccountUuid: async (snsAccountUuid: string, patchViewupPlusSnsAccountByViewupPlusSnsAccountUuidReqBodyDto: PatchViewupPlusSnsAccountByViewupPlusSnsAccountUuidReqBodyDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'snsAccountUuid' is not null or undefined
            assertParamExists('snsAccountControllerPatchViewupPlusSnsAccountBySnsAccountUuid', 'snsAccountUuid', snsAccountUuid)
            // verify required parameter 'patchViewupPlusSnsAccountByViewupPlusSnsAccountUuidReqBodyDto' is not null or undefined
            assertParamExists('snsAccountControllerPatchViewupPlusSnsAccountBySnsAccountUuid', 'patchViewupPlusSnsAccountByViewupPlusSnsAccountUuidReqBodyDto', patchViewupPlusSnsAccountByViewupPlusSnsAccountUuidReqBodyDto)
            const localVarPath = `/sns-accounts/viewupPlus/{snsAccountUuid}`
                .replace(`{${"snsAccountUuid"}}`, encodeURIComponent(String(snsAccountUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication accessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchViewupPlusSnsAccountByViewupPlusSnsAccountUuidReqBodyDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 뷰업 SNS 계정 수정
         * @param {string} snsAccountUuid sns 계정 uuid
         * @param {PatchViewupSnsAccountByViewupSnsAccountUuidReqBodyDto} patchViewupSnsAccountByViewupSnsAccountUuidReqBodyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        snsAccountControllerPatchViewupSnsAccountBySnsAccountUuid: async (snsAccountUuid: string, patchViewupSnsAccountByViewupSnsAccountUuidReqBodyDto: PatchViewupSnsAccountByViewupSnsAccountUuidReqBodyDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'snsAccountUuid' is not null or undefined
            assertParamExists('snsAccountControllerPatchViewupSnsAccountBySnsAccountUuid', 'snsAccountUuid', snsAccountUuid)
            // verify required parameter 'patchViewupSnsAccountByViewupSnsAccountUuidReqBodyDto' is not null or undefined
            assertParamExists('snsAccountControllerPatchViewupSnsAccountBySnsAccountUuid', 'patchViewupSnsAccountByViewupSnsAccountUuidReqBodyDto', patchViewupSnsAccountByViewupSnsAccountUuidReqBodyDto)
            const localVarPath = `/sns-accounts/viewup/{snsAccountUuid}`
                .replace(`{${"snsAccountUuid"}}`, encodeURIComponent(String(snsAccountUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication accessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchViewupSnsAccountByViewupSnsAccountUuidReqBodyDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 뷰업 SNS 계정 활성화 토글
         * @param {string} snsAccountUuid sns 계정 uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        snsAccountControllerPatchViewupSnsAccountIsActiveBySnsAccountUuid: async (snsAccountUuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'snsAccountUuid' is not null or undefined
            assertParamExists('snsAccountControllerPatchViewupSnsAccountIsActiveBySnsAccountUuid', 'snsAccountUuid', snsAccountUuid)
            const localVarPath = `/sns-accounts/viewup/{snsAccountUuid}/active-toggle`
                .replace(`{${"snsAccountUuid"}}`, encodeURIComponent(String(snsAccountUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication accessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 해당 계정이 속한 플랫폼의 여러 계정 중 해당 계정만 활성화
         * @param {string} snsAccountUuid sns 계정 uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        snsAccountControllerPatchViewupSnsAccountOnlyActiveInPlatformBySnsAccountUuid: async (snsAccountUuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'snsAccountUuid' is not null or undefined
            assertParamExists('snsAccountControllerPatchViewupSnsAccountOnlyActiveInPlatformBySnsAccountUuid', 'snsAccountUuid', snsAccountUuid)
            const localVarPath = `/sns-accounts/viewup/{snsAccountUuid}/active`
                .replace(`{${"snsAccountUuid"}}`, encodeURIComponent(String(snsAccountUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication accessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 페이스북 계정 등록(재등록)
         * @param {PostFacebookAccountByUserUuidReqBodyDto} postFacebookAccountByUserUuidReqBodyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        snsAccountControllerPostFacebookAccountByUserUuid: async (postFacebookAccountByUserUuidReqBodyDto: PostFacebookAccountByUserUuidReqBodyDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postFacebookAccountByUserUuidReqBodyDto' is not null or undefined
            assertParamExists('snsAccountControllerPostFacebookAccountByUserUuid', 'postFacebookAccountByUserUuidReqBodyDto', postFacebookAccountByUserUuidReqBodyDto)
            const localVarPath = `/sns-accounts/viewup/facebook`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication accessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postFacebookAccountByUserUuidReqBodyDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 인스타 계정 등록(재등록)
         * @param {SnsAccountControllerPostInstagramAccountByUserUuidSnsAccountEnumEnum} snsAccountEnum 계정 종류
         * @param {PostInstagramAccountByUserUuidReqBodyDto} postInstagramAccountByUserUuidReqBodyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        snsAccountControllerPostInstagramAccountByUserUuid: async (snsAccountEnum: SnsAccountControllerPostInstagramAccountByUserUuidSnsAccountEnumEnum, postInstagramAccountByUserUuidReqBodyDto: PostInstagramAccountByUserUuidReqBodyDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'snsAccountEnum' is not null or undefined
            assertParamExists('snsAccountControllerPostInstagramAccountByUserUuid', 'snsAccountEnum', snsAccountEnum)
            // verify required parameter 'postInstagramAccountByUserUuidReqBodyDto' is not null or undefined
            assertParamExists('snsAccountControllerPostInstagramAccountByUserUuid', 'postInstagramAccountByUserUuidReqBodyDto', postInstagramAccountByUserUuidReqBodyDto)
            const localVarPath = `/sns-accounts/{snsAccountEnum}/instagram`
                .replace(`{${"snsAccountEnum"}}`, encodeURIComponent(String(snsAccountEnum)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication accessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postInstagramAccountByUserUuidReqBodyDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary sns 계정 로그아웃
         * @param {PostLogoutSnsAccountRequestBodyDto} postLogoutSnsAccountRequestBodyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        snsAccountControllerPostLogoutSnsAccount: async (postLogoutSnsAccountRequestBodyDto: PostLogoutSnsAccountRequestBodyDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postLogoutSnsAccountRequestBodyDto' is not null or undefined
            assertParamExists('snsAccountControllerPostLogoutSnsAccount', 'postLogoutSnsAccountRequestBodyDto', postLogoutSnsAccountRequestBodyDto)
            const localVarPath = `/sns-accounts/logout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication accessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postLogoutSnsAccountRequestBodyDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 스레드 계정 등록(재등록)
         * @param {PostThreadsAccountByUserUuidReqBodyDto} postThreadsAccountByUserUuidReqBodyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        snsAccountControllerPostThreadsAccountByUserUuid: async (postThreadsAccountByUserUuidReqBodyDto: PostThreadsAccountByUserUuidReqBodyDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postThreadsAccountByUserUuidReqBodyDto' is not null or undefined
            assertParamExists('snsAccountControllerPostThreadsAccountByUserUuid', 'postThreadsAccountByUserUuidReqBodyDto', postThreadsAccountByUserUuidReqBodyDto)
            const localVarPath = `/sns-accounts/viewup/threads`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication accessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postThreadsAccountByUserUuidReqBodyDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 유튜브 계정 등록(재등록)
         * @param {PostYoutubeAccountByUserUuidReqBodyDto} postYoutubeAccountByUserUuidReqBodyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        snsAccountControllerPostYoutubeAccountByUserUuid: async (postYoutubeAccountByUserUuidReqBodyDto: PostYoutubeAccountByUserUuidReqBodyDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postYoutubeAccountByUserUuidReqBodyDto' is not null or undefined
            assertParamExists('snsAccountControllerPostYoutubeAccountByUserUuid', 'postYoutubeAccountByUserUuidReqBodyDto', postYoutubeAccountByUserUuidReqBodyDto)
            const localVarPath = `/sns-accounts/viewup/youtube`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication accessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postYoutubeAccountByUserUuidReqBodyDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        snsAccountControllerPpap: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/sns-accounts/ppappapapapapapapapapapapa`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SnsAccountsApi - functional programming interface
 * @export
 */
export const SnsAccountsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SnsAccountsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 뷰업 플러스 SNS 계정 삭제
         * @param {string} snsAccountUuid sns 계정 uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async snsAccountControllerDeleteViewupPlusSnsAccountBySnsAccountUuid(snsAccountUuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.snsAccountControllerDeleteViewupPlusSnsAccountBySnsAccountUuid(snsAccountUuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SnsAccountsApi.snsAccountControllerDeleteViewupPlusSnsAccountBySnsAccountUuid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 뷰업 SNS 계정 삭제
         * @param {string} snsAccountUuid sns 계정 uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async snsAccountControllerDeleteViewupSnsAccountBySnsAccountUuid(snsAccountUuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.snsAccountControllerDeleteViewupSnsAccountBySnsAccountUuid(snsAccountUuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SnsAccountsApi.snsAccountControllerDeleteViewupSnsAccountBySnsAccountUuid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 활성화 뷰업 SNS 계정 목록 조회
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async snsAccountControllerGetActiveViewupSnsAccountsByUserUuid(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetActiveViewupSnsAccountsByUserUuidOkDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.snsAccountControllerGetActiveViewupSnsAccountsByUserUuid(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SnsAccountsApi.snsAccountControllerGetActiveViewupSnsAccountsByUserUuid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 계정 삭제시 차감 예정 금액
         * @param {string} snsAccountUuid sns 계정 uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async snsAccountControllerGetAmountBeDeducted(snsAccountUuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAmountBeDeductedOkDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.snsAccountControllerGetAmountBeDeducted(snsAccountUuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SnsAccountsApi.snsAccountControllerGetAmountBeDeducted']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 모두그램에서 호출: 뷰플 승인 계정 목록
         * @param {boolean} [isActivity] 활동기능 여부
         * @param {boolean} [isRegram] 리그램 여부
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async snsAccountControllerGetApprovedViewupPlusSnsAccounts(isActivity?: boolean, isRegram?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetApprovedViewupPlusSnsAccountsOkDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.snsAccountControllerGetApprovedViewupPlusSnsAccounts(isActivity, isRegram, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SnsAccountsApi.snsAccountControllerGetApprovedViewupPlusSnsAccounts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 뷰업 플러스 SNS 계정 목록 조회
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async snsAccountControllerGetViewupPlusSnsAccountsByUserUuid(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetViewupPlusSnsAccountsByUserUuidOkDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.snsAccountControllerGetViewupPlusSnsAccountsByUserUuid(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SnsAccountsApi.snsAccountControllerGetViewupPlusSnsAccountsByUserUuid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 뷰업 SNS 계정 목록 조회
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async snsAccountControllerGetViewupSnsAccountsByUserUuid(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetViewupSnsAccountsByUserUuidOkDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.snsAccountControllerGetViewupSnsAccountsByUserUuid(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SnsAccountsApi.snsAccountControllerGetViewupSnsAccountsByUserUuid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 뷰플 SNS 계정 수정
         * @param {string} snsAccountUuid sns 계정 uuid
         * @param {PatchViewupPlusSnsAccountByViewupPlusSnsAccountUuidReqBodyDto} patchViewupPlusSnsAccountByViewupPlusSnsAccountUuidReqBodyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async snsAccountControllerPatchViewupPlusSnsAccountBySnsAccountUuid(snsAccountUuid: string, patchViewupPlusSnsAccountByViewupPlusSnsAccountUuidReqBodyDto: PatchViewupPlusSnsAccountByViewupPlusSnsAccountUuidReqBodyDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.snsAccountControllerPatchViewupPlusSnsAccountBySnsAccountUuid(snsAccountUuid, patchViewupPlusSnsAccountByViewupPlusSnsAccountUuidReqBodyDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SnsAccountsApi.snsAccountControllerPatchViewupPlusSnsAccountBySnsAccountUuid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 뷰업 SNS 계정 수정
         * @param {string} snsAccountUuid sns 계정 uuid
         * @param {PatchViewupSnsAccountByViewupSnsAccountUuidReqBodyDto} patchViewupSnsAccountByViewupSnsAccountUuidReqBodyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async snsAccountControllerPatchViewupSnsAccountBySnsAccountUuid(snsAccountUuid: string, patchViewupSnsAccountByViewupSnsAccountUuidReqBodyDto: PatchViewupSnsAccountByViewupSnsAccountUuidReqBodyDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.snsAccountControllerPatchViewupSnsAccountBySnsAccountUuid(snsAccountUuid, patchViewupSnsAccountByViewupSnsAccountUuidReqBodyDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SnsAccountsApi.snsAccountControllerPatchViewupSnsAccountBySnsAccountUuid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 뷰업 SNS 계정 활성화 토글
         * @param {string} snsAccountUuid sns 계정 uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async snsAccountControllerPatchViewupSnsAccountIsActiveBySnsAccountUuid(snsAccountUuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.snsAccountControllerPatchViewupSnsAccountIsActiveBySnsAccountUuid(snsAccountUuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SnsAccountsApi.snsAccountControllerPatchViewupSnsAccountIsActiveBySnsAccountUuid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 해당 계정이 속한 플랫폼의 여러 계정 중 해당 계정만 활성화
         * @param {string} snsAccountUuid sns 계정 uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async snsAccountControllerPatchViewupSnsAccountOnlyActiveInPlatformBySnsAccountUuid(snsAccountUuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PatchViewupSnsAccountOnlyActiveInPlatformBySnsAccountUuidOkDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.snsAccountControllerPatchViewupSnsAccountOnlyActiveInPlatformBySnsAccountUuid(snsAccountUuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SnsAccountsApi.snsAccountControllerPatchViewupSnsAccountOnlyActiveInPlatformBySnsAccountUuid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 페이스북 계정 등록(재등록)
         * @param {PostFacebookAccountByUserUuidReqBodyDto} postFacebookAccountByUserUuidReqBodyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async snsAccountControllerPostFacebookAccountByUserUuid(postFacebookAccountByUserUuidReqBodyDto: PostFacebookAccountByUserUuidReqBodyDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.snsAccountControllerPostFacebookAccountByUserUuid(postFacebookAccountByUserUuidReqBodyDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SnsAccountsApi.snsAccountControllerPostFacebookAccountByUserUuid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 인스타 계정 등록(재등록)
         * @param {SnsAccountControllerPostInstagramAccountByUserUuidSnsAccountEnumEnum} snsAccountEnum 계정 종류
         * @param {PostInstagramAccountByUserUuidReqBodyDto} postInstagramAccountByUserUuidReqBodyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async snsAccountControllerPostInstagramAccountByUserUuid(snsAccountEnum: SnsAccountControllerPostInstagramAccountByUserUuidSnsAccountEnumEnum, postInstagramAccountByUserUuidReqBodyDto: PostInstagramAccountByUserUuidReqBodyDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.snsAccountControllerPostInstagramAccountByUserUuid(snsAccountEnum, postInstagramAccountByUserUuidReqBodyDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SnsAccountsApi.snsAccountControllerPostInstagramAccountByUserUuid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary sns 계정 로그아웃
         * @param {PostLogoutSnsAccountRequestBodyDto} postLogoutSnsAccountRequestBodyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async snsAccountControllerPostLogoutSnsAccount(postLogoutSnsAccountRequestBodyDto: PostLogoutSnsAccountRequestBodyDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostLogoutSnsAccountResponseOkDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.snsAccountControllerPostLogoutSnsAccount(postLogoutSnsAccountRequestBodyDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SnsAccountsApi.snsAccountControllerPostLogoutSnsAccount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 스레드 계정 등록(재등록)
         * @param {PostThreadsAccountByUserUuidReqBodyDto} postThreadsAccountByUserUuidReqBodyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async snsAccountControllerPostThreadsAccountByUserUuid(postThreadsAccountByUserUuidReqBodyDto: PostThreadsAccountByUserUuidReqBodyDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.snsAccountControllerPostThreadsAccountByUserUuid(postThreadsAccountByUserUuidReqBodyDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SnsAccountsApi.snsAccountControllerPostThreadsAccountByUserUuid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 유튜브 계정 등록(재등록)
         * @param {PostYoutubeAccountByUserUuidReqBodyDto} postYoutubeAccountByUserUuidReqBodyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async snsAccountControllerPostYoutubeAccountByUserUuid(postYoutubeAccountByUserUuidReqBodyDto: PostYoutubeAccountByUserUuidReqBodyDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.snsAccountControllerPostYoutubeAccountByUserUuid(postYoutubeAccountByUserUuidReqBodyDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SnsAccountsApi.snsAccountControllerPostYoutubeAccountByUserUuid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async snsAccountControllerPpap(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.snsAccountControllerPpap(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SnsAccountsApi.snsAccountControllerPpap']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SnsAccountsApi - factory interface
 * @export
 */
export const SnsAccountsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SnsAccountsApiFp(configuration)
    return {
        /**
         * 
         * @summary 뷰업 플러스 SNS 계정 삭제
         * @param {SnsAccountsApiSnsAccountControllerDeleteViewupPlusSnsAccountBySnsAccountUuidRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        snsAccountControllerDeleteViewupPlusSnsAccountBySnsAccountUuid(requestParameters: SnsAccountsApiSnsAccountControllerDeleteViewupPlusSnsAccountBySnsAccountUuidRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.snsAccountControllerDeleteViewupPlusSnsAccountBySnsAccountUuid(requestParameters.snsAccountUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 뷰업 SNS 계정 삭제
         * @param {SnsAccountsApiSnsAccountControllerDeleteViewupSnsAccountBySnsAccountUuidRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        snsAccountControllerDeleteViewupSnsAccountBySnsAccountUuid(requestParameters: SnsAccountsApiSnsAccountControllerDeleteViewupSnsAccountBySnsAccountUuidRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.snsAccountControllerDeleteViewupSnsAccountBySnsAccountUuid(requestParameters.snsAccountUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 활성화 뷰업 SNS 계정 목록 조회
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        snsAccountControllerGetActiveViewupSnsAccountsByUserUuid(options?: RawAxiosRequestConfig): AxiosPromise<GetActiveViewupSnsAccountsByUserUuidOkDto> {
            return localVarFp.snsAccountControllerGetActiveViewupSnsAccountsByUserUuid(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 계정 삭제시 차감 예정 금액
         * @param {SnsAccountsApiSnsAccountControllerGetAmountBeDeductedRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        snsAccountControllerGetAmountBeDeducted(requestParameters: SnsAccountsApiSnsAccountControllerGetAmountBeDeductedRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetAmountBeDeductedOkDto> {
            return localVarFp.snsAccountControllerGetAmountBeDeducted(requestParameters.snsAccountUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 모두그램에서 호출: 뷰플 승인 계정 목록
         * @param {SnsAccountsApiSnsAccountControllerGetApprovedViewupPlusSnsAccountsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        snsAccountControllerGetApprovedViewupPlusSnsAccounts(requestParameters: SnsAccountsApiSnsAccountControllerGetApprovedViewupPlusSnsAccountsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetApprovedViewupPlusSnsAccountsOkDto> {
            return localVarFp.snsAccountControllerGetApprovedViewupPlusSnsAccounts(requestParameters.isActivity, requestParameters.isRegram, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 뷰업 플러스 SNS 계정 목록 조회
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        snsAccountControllerGetViewupPlusSnsAccountsByUserUuid(options?: RawAxiosRequestConfig): AxiosPromise<GetViewupPlusSnsAccountsByUserUuidOkDto> {
            return localVarFp.snsAccountControllerGetViewupPlusSnsAccountsByUserUuid(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 뷰업 SNS 계정 목록 조회
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        snsAccountControllerGetViewupSnsAccountsByUserUuid(options?: RawAxiosRequestConfig): AxiosPromise<GetViewupSnsAccountsByUserUuidOkDto> {
            return localVarFp.snsAccountControllerGetViewupSnsAccountsByUserUuid(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 뷰플 SNS 계정 수정
         * @param {SnsAccountsApiSnsAccountControllerPatchViewupPlusSnsAccountBySnsAccountUuidRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        snsAccountControllerPatchViewupPlusSnsAccountBySnsAccountUuid(requestParameters: SnsAccountsApiSnsAccountControllerPatchViewupPlusSnsAccountBySnsAccountUuidRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.snsAccountControllerPatchViewupPlusSnsAccountBySnsAccountUuid(requestParameters.snsAccountUuid, requestParameters.patchViewupPlusSnsAccountByViewupPlusSnsAccountUuidReqBodyDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 뷰업 SNS 계정 수정
         * @param {SnsAccountsApiSnsAccountControllerPatchViewupSnsAccountBySnsAccountUuidRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        snsAccountControllerPatchViewupSnsAccountBySnsAccountUuid(requestParameters: SnsAccountsApiSnsAccountControllerPatchViewupSnsAccountBySnsAccountUuidRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.snsAccountControllerPatchViewupSnsAccountBySnsAccountUuid(requestParameters.snsAccountUuid, requestParameters.patchViewupSnsAccountByViewupSnsAccountUuidReqBodyDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 뷰업 SNS 계정 활성화 토글
         * @param {SnsAccountsApiSnsAccountControllerPatchViewupSnsAccountIsActiveBySnsAccountUuidRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        snsAccountControllerPatchViewupSnsAccountIsActiveBySnsAccountUuid(requestParameters: SnsAccountsApiSnsAccountControllerPatchViewupSnsAccountIsActiveBySnsAccountUuidRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.snsAccountControllerPatchViewupSnsAccountIsActiveBySnsAccountUuid(requestParameters.snsAccountUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 해당 계정이 속한 플랫폼의 여러 계정 중 해당 계정만 활성화
         * @param {SnsAccountsApiSnsAccountControllerPatchViewupSnsAccountOnlyActiveInPlatformBySnsAccountUuidRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        snsAccountControllerPatchViewupSnsAccountOnlyActiveInPlatformBySnsAccountUuid(requestParameters: SnsAccountsApiSnsAccountControllerPatchViewupSnsAccountOnlyActiveInPlatformBySnsAccountUuidRequest, options?: RawAxiosRequestConfig): AxiosPromise<PatchViewupSnsAccountOnlyActiveInPlatformBySnsAccountUuidOkDto> {
            return localVarFp.snsAccountControllerPatchViewupSnsAccountOnlyActiveInPlatformBySnsAccountUuid(requestParameters.snsAccountUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 페이스북 계정 등록(재등록)
         * @param {SnsAccountsApiSnsAccountControllerPostFacebookAccountByUserUuidRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        snsAccountControllerPostFacebookAccountByUserUuid(requestParameters: SnsAccountsApiSnsAccountControllerPostFacebookAccountByUserUuidRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.snsAccountControllerPostFacebookAccountByUserUuid(requestParameters.postFacebookAccountByUserUuidReqBodyDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 인스타 계정 등록(재등록)
         * @param {SnsAccountsApiSnsAccountControllerPostInstagramAccountByUserUuidRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        snsAccountControllerPostInstagramAccountByUserUuid(requestParameters: SnsAccountsApiSnsAccountControllerPostInstagramAccountByUserUuidRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.snsAccountControllerPostInstagramAccountByUserUuid(requestParameters.snsAccountEnum, requestParameters.postInstagramAccountByUserUuidReqBodyDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary sns 계정 로그아웃
         * @param {SnsAccountsApiSnsAccountControllerPostLogoutSnsAccountRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        snsAccountControllerPostLogoutSnsAccount(requestParameters: SnsAccountsApiSnsAccountControllerPostLogoutSnsAccountRequest, options?: RawAxiosRequestConfig): AxiosPromise<PostLogoutSnsAccountResponseOkDto> {
            return localVarFp.snsAccountControllerPostLogoutSnsAccount(requestParameters.postLogoutSnsAccountRequestBodyDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 스레드 계정 등록(재등록)
         * @param {SnsAccountsApiSnsAccountControllerPostThreadsAccountByUserUuidRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        snsAccountControllerPostThreadsAccountByUserUuid(requestParameters: SnsAccountsApiSnsAccountControllerPostThreadsAccountByUserUuidRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.snsAccountControllerPostThreadsAccountByUserUuid(requestParameters.postThreadsAccountByUserUuidReqBodyDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 유튜브 계정 등록(재등록)
         * @param {SnsAccountsApiSnsAccountControllerPostYoutubeAccountByUserUuidRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        snsAccountControllerPostYoutubeAccountByUserUuid(requestParameters: SnsAccountsApiSnsAccountControllerPostYoutubeAccountByUserUuidRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.snsAccountControllerPostYoutubeAccountByUserUuid(requestParameters.postYoutubeAccountByUserUuidReqBodyDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        snsAccountControllerPpap(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.snsAccountControllerPpap(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for snsAccountControllerDeleteViewupPlusSnsAccountBySnsAccountUuid operation in SnsAccountsApi.
 * @export
 * @interface SnsAccountsApiSnsAccountControllerDeleteViewupPlusSnsAccountBySnsAccountUuidRequest
 */
export interface SnsAccountsApiSnsAccountControllerDeleteViewupPlusSnsAccountBySnsAccountUuidRequest {
    /**
     * sns 계정 uuid
     * @type {string}
     * @memberof SnsAccountsApiSnsAccountControllerDeleteViewupPlusSnsAccountBySnsAccountUuid
     */
    readonly snsAccountUuid: string
}

/**
 * Request parameters for snsAccountControllerDeleteViewupSnsAccountBySnsAccountUuid operation in SnsAccountsApi.
 * @export
 * @interface SnsAccountsApiSnsAccountControllerDeleteViewupSnsAccountBySnsAccountUuidRequest
 */
export interface SnsAccountsApiSnsAccountControllerDeleteViewupSnsAccountBySnsAccountUuidRequest {
    /**
     * sns 계정 uuid
     * @type {string}
     * @memberof SnsAccountsApiSnsAccountControllerDeleteViewupSnsAccountBySnsAccountUuid
     */
    readonly snsAccountUuid: string
}

/**
 * Request parameters for snsAccountControllerGetAmountBeDeducted operation in SnsAccountsApi.
 * @export
 * @interface SnsAccountsApiSnsAccountControllerGetAmountBeDeductedRequest
 */
export interface SnsAccountsApiSnsAccountControllerGetAmountBeDeductedRequest {
    /**
     * sns 계정 uuid
     * @type {string}
     * @memberof SnsAccountsApiSnsAccountControllerGetAmountBeDeducted
     */
    readonly snsAccountUuid: string
}

/**
 * Request parameters for snsAccountControllerGetApprovedViewupPlusSnsAccounts operation in SnsAccountsApi.
 * @export
 * @interface SnsAccountsApiSnsAccountControllerGetApprovedViewupPlusSnsAccountsRequest
 */
export interface SnsAccountsApiSnsAccountControllerGetApprovedViewupPlusSnsAccountsRequest {
    /**
     * 활동기능 여부
     * @type {boolean}
     * @memberof SnsAccountsApiSnsAccountControllerGetApprovedViewupPlusSnsAccounts
     */
    readonly isActivity?: boolean

    /**
     * 리그램 여부
     * @type {boolean}
     * @memberof SnsAccountsApiSnsAccountControllerGetApprovedViewupPlusSnsAccounts
     */
    readonly isRegram?: boolean
}

/**
 * Request parameters for snsAccountControllerPatchViewupPlusSnsAccountBySnsAccountUuid operation in SnsAccountsApi.
 * @export
 * @interface SnsAccountsApiSnsAccountControllerPatchViewupPlusSnsAccountBySnsAccountUuidRequest
 */
export interface SnsAccountsApiSnsAccountControllerPatchViewupPlusSnsAccountBySnsAccountUuidRequest {
    /**
     * sns 계정 uuid
     * @type {string}
     * @memberof SnsAccountsApiSnsAccountControllerPatchViewupPlusSnsAccountBySnsAccountUuid
     */
    readonly snsAccountUuid: string

    /**
     * 
     * @type {PatchViewupPlusSnsAccountByViewupPlusSnsAccountUuidReqBodyDto}
     * @memberof SnsAccountsApiSnsAccountControllerPatchViewupPlusSnsAccountBySnsAccountUuid
     */
    readonly patchViewupPlusSnsAccountByViewupPlusSnsAccountUuidReqBodyDto: PatchViewupPlusSnsAccountByViewupPlusSnsAccountUuidReqBodyDto
}

/**
 * Request parameters for snsAccountControllerPatchViewupSnsAccountBySnsAccountUuid operation in SnsAccountsApi.
 * @export
 * @interface SnsAccountsApiSnsAccountControllerPatchViewupSnsAccountBySnsAccountUuidRequest
 */
export interface SnsAccountsApiSnsAccountControllerPatchViewupSnsAccountBySnsAccountUuidRequest {
    /**
     * sns 계정 uuid
     * @type {string}
     * @memberof SnsAccountsApiSnsAccountControllerPatchViewupSnsAccountBySnsAccountUuid
     */
    readonly snsAccountUuid: string

    /**
     * 
     * @type {PatchViewupSnsAccountByViewupSnsAccountUuidReqBodyDto}
     * @memberof SnsAccountsApiSnsAccountControllerPatchViewupSnsAccountBySnsAccountUuid
     */
    readonly patchViewupSnsAccountByViewupSnsAccountUuidReqBodyDto: PatchViewupSnsAccountByViewupSnsAccountUuidReqBodyDto
}

/**
 * Request parameters for snsAccountControllerPatchViewupSnsAccountIsActiveBySnsAccountUuid operation in SnsAccountsApi.
 * @export
 * @interface SnsAccountsApiSnsAccountControllerPatchViewupSnsAccountIsActiveBySnsAccountUuidRequest
 */
export interface SnsAccountsApiSnsAccountControllerPatchViewupSnsAccountIsActiveBySnsAccountUuidRequest {
    /**
     * sns 계정 uuid
     * @type {string}
     * @memberof SnsAccountsApiSnsAccountControllerPatchViewupSnsAccountIsActiveBySnsAccountUuid
     */
    readonly snsAccountUuid: string
}

/**
 * Request parameters for snsAccountControllerPatchViewupSnsAccountOnlyActiveInPlatformBySnsAccountUuid operation in SnsAccountsApi.
 * @export
 * @interface SnsAccountsApiSnsAccountControllerPatchViewupSnsAccountOnlyActiveInPlatformBySnsAccountUuidRequest
 */
export interface SnsAccountsApiSnsAccountControllerPatchViewupSnsAccountOnlyActiveInPlatformBySnsAccountUuidRequest {
    /**
     * sns 계정 uuid
     * @type {string}
     * @memberof SnsAccountsApiSnsAccountControllerPatchViewupSnsAccountOnlyActiveInPlatformBySnsAccountUuid
     */
    readonly snsAccountUuid: string
}

/**
 * Request parameters for snsAccountControllerPostFacebookAccountByUserUuid operation in SnsAccountsApi.
 * @export
 * @interface SnsAccountsApiSnsAccountControllerPostFacebookAccountByUserUuidRequest
 */
export interface SnsAccountsApiSnsAccountControllerPostFacebookAccountByUserUuidRequest {
    /**
     * 
     * @type {PostFacebookAccountByUserUuidReqBodyDto}
     * @memberof SnsAccountsApiSnsAccountControllerPostFacebookAccountByUserUuid
     */
    readonly postFacebookAccountByUserUuidReqBodyDto: PostFacebookAccountByUserUuidReqBodyDto
}

/**
 * Request parameters for snsAccountControllerPostInstagramAccountByUserUuid operation in SnsAccountsApi.
 * @export
 * @interface SnsAccountsApiSnsAccountControllerPostInstagramAccountByUserUuidRequest
 */
export interface SnsAccountsApiSnsAccountControllerPostInstagramAccountByUserUuidRequest {
    /**
     * 계정 종류
     * @type {'viewup' | 'viewupPlus'}
     * @memberof SnsAccountsApiSnsAccountControllerPostInstagramAccountByUserUuid
     */
    readonly snsAccountEnum: SnsAccountControllerPostInstagramAccountByUserUuidSnsAccountEnumEnum

    /**
     * 
     * @type {PostInstagramAccountByUserUuidReqBodyDto}
     * @memberof SnsAccountsApiSnsAccountControllerPostInstagramAccountByUserUuid
     */
    readonly postInstagramAccountByUserUuidReqBodyDto: PostInstagramAccountByUserUuidReqBodyDto
}

/**
 * Request parameters for snsAccountControllerPostLogoutSnsAccount operation in SnsAccountsApi.
 * @export
 * @interface SnsAccountsApiSnsAccountControllerPostLogoutSnsAccountRequest
 */
export interface SnsAccountsApiSnsAccountControllerPostLogoutSnsAccountRequest {
    /**
     * 
     * @type {PostLogoutSnsAccountRequestBodyDto}
     * @memberof SnsAccountsApiSnsAccountControllerPostLogoutSnsAccount
     */
    readonly postLogoutSnsAccountRequestBodyDto: PostLogoutSnsAccountRequestBodyDto
}

/**
 * Request parameters for snsAccountControllerPostThreadsAccountByUserUuid operation in SnsAccountsApi.
 * @export
 * @interface SnsAccountsApiSnsAccountControllerPostThreadsAccountByUserUuidRequest
 */
export interface SnsAccountsApiSnsAccountControllerPostThreadsAccountByUserUuidRequest {
    /**
     * 
     * @type {PostThreadsAccountByUserUuidReqBodyDto}
     * @memberof SnsAccountsApiSnsAccountControllerPostThreadsAccountByUserUuid
     */
    readonly postThreadsAccountByUserUuidReqBodyDto: PostThreadsAccountByUserUuidReqBodyDto
}

/**
 * Request parameters for snsAccountControllerPostYoutubeAccountByUserUuid operation in SnsAccountsApi.
 * @export
 * @interface SnsAccountsApiSnsAccountControllerPostYoutubeAccountByUserUuidRequest
 */
export interface SnsAccountsApiSnsAccountControllerPostYoutubeAccountByUserUuidRequest {
    /**
     * 
     * @type {PostYoutubeAccountByUserUuidReqBodyDto}
     * @memberof SnsAccountsApiSnsAccountControllerPostYoutubeAccountByUserUuid
     */
    readonly postYoutubeAccountByUserUuidReqBodyDto: PostYoutubeAccountByUserUuidReqBodyDto
}

/**
 * SnsAccountsApi - object-oriented interface
 * @export
 * @class SnsAccountsApi
 * @extends {BaseAPI}
 */
export class SnsAccountsApi extends BaseAPI {
    /**
     * 
     * @summary 뷰업 플러스 SNS 계정 삭제
     * @param {SnsAccountsApiSnsAccountControllerDeleteViewupPlusSnsAccountBySnsAccountUuidRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SnsAccountsApi
     */
    public snsAccountControllerDeleteViewupPlusSnsAccountBySnsAccountUuid(requestParameters: SnsAccountsApiSnsAccountControllerDeleteViewupPlusSnsAccountBySnsAccountUuidRequest, options?: RawAxiosRequestConfig) {
        return SnsAccountsApiFp(this.configuration).snsAccountControllerDeleteViewupPlusSnsAccountBySnsAccountUuid(requestParameters.snsAccountUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 뷰업 SNS 계정 삭제
     * @param {SnsAccountsApiSnsAccountControllerDeleteViewupSnsAccountBySnsAccountUuidRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SnsAccountsApi
     */
    public snsAccountControllerDeleteViewupSnsAccountBySnsAccountUuid(requestParameters: SnsAccountsApiSnsAccountControllerDeleteViewupSnsAccountBySnsAccountUuidRequest, options?: RawAxiosRequestConfig) {
        return SnsAccountsApiFp(this.configuration).snsAccountControllerDeleteViewupSnsAccountBySnsAccountUuid(requestParameters.snsAccountUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 활성화 뷰업 SNS 계정 목록 조회
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SnsAccountsApi
     */
    public snsAccountControllerGetActiveViewupSnsAccountsByUserUuid(options?: RawAxiosRequestConfig) {
        return SnsAccountsApiFp(this.configuration).snsAccountControllerGetActiveViewupSnsAccountsByUserUuid(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 계정 삭제시 차감 예정 금액
     * @param {SnsAccountsApiSnsAccountControllerGetAmountBeDeductedRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SnsAccountsApi
     */
    public snsAccountControllerGetAmountBeDeducted(requestParameters: SnsAccountsApiSnsAccountControllerGetAmountBeDeductedRequest, options?: RawAxiosRequestConfig) {
        return SnsAccountsApiFp(this.configuration).snsAccountControllerGetAmountBeDeducted(requestParameters.snsAccountUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 모두그램에서 호출: 뷰플 승인 계정 목록
     * @param {SnsAccountsApiSnsAccountControllerGetApprovedViewupPlusSnsAccountsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SnsAccountsApi
     */
    public snsAccountControllerGetApprovedViewupPlusSnsAccounts(requestParameters: SnsAccountsApiSnsAccountControllerGetApprovedViewupPlusSnsAccountsRequest = {}, options?: RawAxiosRequestConfig) {
        return SnsAccountsApiFp(this.configuration).snsAccountControllerGetApprovedViewupPlusSnsAccounts(requestParameters.isActivity, requestParameters.isRegram, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 뷰업 플러스 SNS 계정 목록 조회
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SnsAccountsApi
     */
    public snsAccountControllerGetViewupPlusSnsAccountsByUserUuid(options?: RawAxiosRequestConfig) {
        return SnsAccountsApiFp(this.configuration).snsAccountControllerGetViewupPlusSnsAccountsByUserUuid(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 뷰업 SNS 계정 목록 조회
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SnsAccountsApi
     */
    public snsAccountControllerGetViewupSnsAccountsByUserUuid(options?: RawAxiosRequestConfig) {
        return SnsAccountsApiFp(this.configuration).snsAccountControllerGetViewupSnsAccountsByUserUuid(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 뷰플 SNS 계정 수정
     * @param {SnsAccountsApiSnsAccountControllerPatchViewupPlusSnsAccountBySnsAccountUuidRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SnsAccountsApi
     */
    public snsAccountControllerPatchViewupPlusSnsAccountBySnsAccountUuid(requestParameters: SnsAccountsApiSnsAccountControllerPatchViewupPlusSnsAccountBySnsAccountUuidRequest, options?: RawAxiosRequestConfig) {
        return SnsAccountsApiFp(this.configuration).snsAccountControllerPatchViewupPlusSnsAccountBySnsAccountUuid(requestParameters.snsAccountUuid, requestParameters.patchViewupPlusSnsAccountByViewupPlusSnsAccountUuidReqBodyDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 뷰업 SNS 계정 수정
     * @param {SnsAccountsApiSnsAccountControllerPatchViewupSnsAccountBySnsAccountUuidRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SnsAccountsApi
     */
    public snsAccountControllerPatchViewupSnsAccountBySnsAccountUuid(requestParameters: SnsAccountsApiSnsAccountControllerPatchViewupSnsAccountBySnsAccountUuidRequest, options?: RawAxiosRequestConfig) {
        return SnsAccountsApiFp(this.configuration).snsAccountControllerPatchViewupSnsAccountBySnsAccountUuid(requestParameters.snsAccountUuid, requestParameters.patchViewupSnsAccountByViewupSnsAccountUuidReqBodyDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 뷰업 SNS 계정 활성화 토글
     * @param {SnsAccountsApiSnsAccountControllerPatchViewupSnsAccountIsActiveBySnsAccountUuidRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SnsAccountsApi
     */
    public snsAccountControllerPatchViewupSnsAccountIsActiveBySnsAccountUuid(requestParameters: SnsAccountsApiSnsAccountControllerPatchViewupSnsAccountIsActiveBySnsAccountUuidRequest, options?: RawAxiosRequestConfig) {
        return SnsAccountsApiFp(this.configuration).snsAccountControllerPatchViewupSnsAccountIsActiveBySnsAccountUuid(requestParameters.snsAccountUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 해당 계정이 속한 플랫폼의 여러 계정 중 해당 계정만 활성화
     * @param {SnsAccountsApiSnsAccountControllerPatchViewupSnsAccountOnlyActiveInPlatformBySnsAccountUuidRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SnsAccountsApi
     */
    public snsAccountControllerPatchViewupSnsAccountOnlyActiveInPlatformBySnsAccountUuid(requestParameters: SnsAccountsApiSnsAccountControllerPatchViewupSnsAccountOnlyActiveInPlatformBySnsAccountUuidRequest, options?: RawAxiosRequestConfig) {
        return SnsAccountsApiFp(this.configuration).snsAccountControllerPatchViewupSnsAccountOnlyActiveInPlatformBySnsAccountUuid(requestParameters.snsAccountUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 페이스북 계정 등록(재등록)
     * @param {SnsAccountsApiSnsAccountControllerPostFacebookAccountByUserUuidRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SnsAccountsApi
     */
    public snsAccountControllerPostFacebookAccountByUserUuid(requestParameters: SnsAccountsApiSnsAccountControllerPostFacebookAccountByUserUuidRequest, options?: RawAxiosRequestConfig) {
        return SnsAccountsApiFp(this.configuration).snsAccountControllerPostFacebookAccountByUserUuid(requestParameters.postFacebookAccountByUserUuidReqBodyDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 인스타 계정 등록(재등록)
     * @param {SnsAccountsApiSnsAccountControllerPostInstagramAccountByUserUuidRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SnsAccountsApi
     */
    public snsAccountControllerPostInstagramAccountByUserUuid(requestParameters: SnsAccountsApiSnsAccountControllerPostInstagramAccountByUserUuidRequest, options?: RawAxiosRequestConfig) {
        return SnsAccountsApiFp(this.configuration).snsAccountControllerPostInstagramAccountByUserUuid(requestParameters.snsAccountEnum, requestParameters.postInstagramAccountByUserUuidReqBodyDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary sns 계정 로그아웃
     * @param {SnsAccountsApiSnsAccountControllerPostLogoutSnsAccountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SnsAccountsApi
     */
    public snsAccountControllerPostLogoutSnsAccount(requestParameters: SnsAccountsApiSnsAccountControllerPostLogoutSnsAccountRequest, options?: RawAxiosRequestConfig) {
        return SnsAccountsApiFp(this.configuration).snsAccountControllerPostLogoutSnsAccount(requestParameters.postLogoutSnsAccountRequestBodyDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 스레드 계정 등록(재등록)
     * @param {SnsAccountsApiSnsAccountControllerPostThreadsAccountByUserUuidRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SnsAccountsApi
     */
    public snsAccountControllerPostThreadsAccountByUserUuid(requestParameters: SnsAccountsApiSnsAccountControllerPostThreadsAccountByUserUuidRequest, options?: RawAxiosRequestConfig) {
        return SnsAccountsApiFp(this.configuration).snsAccountControllerPostThreadsAccountByUserUuid(requestParameters.postThreadsAccountByUserUuidReqBodyDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 유튜브 계정 등록(재등록)
     * @param {SnsAccountsApiSnsAccountControllerPostYoutubeAccountByUserUuidRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SnsAccountsApi
     */
    public snsAccountControllerPostYoutubeAccountByUserUuid(requestParameters: SnsAccountsApiSnsAccountControllerPostYoutubeAccountByUserUuidRequest, options?: RawAxiosRequestConfig) {
        return SnsAccountsApiFp(this.configuration).snsAccountControllerPostYoutubeAccountByUserUuid(requestParameters.postYoutubeAccountByUserUuidReqBodyDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SnsAccountsApi
     */
    public snsAccountControllerPpap(options?: RawAxiosRequestConfig) {
        return SnsAccountsApiFp(this.configuration).snsAccountControllerPpap(options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const SnsAccountControllerPostInstagramAccountByUserUuidSnsAccountEnumEnum = {
    Viewup: 'viewup',
    ViewupPlus: 'viewupPlus'
} as const;
export type SnsAccountControllerPostInstagramAccountByUserUuidSnsAccountEnumEnum = typeof SnsAccountControllerPostInstagramAccountByUserUuidSnsAccountEnumEnum[keyof typeof SnsAccountControllerPostInstagramAccountByUserUuidSnsAccountEnumEnum];
